import ReactDOM from 'react-dom'

export function PortalRoot({ children }) {
    return ReactDOM.createPortal(
        children,
        document.getElementById("portal-root")
    )
}